module.exports = __webpack_public_path__ + "static/media/Blue-background-logo.0f9ebd94.png";